<script lang="ts" setup>
import { onMounted, onUnmounted } from 'vue';
import { useRouter } from 'vue-router';
import { BaseSnackbar } from './assets/base_components/';
import { useHtmlMeta } from '@/hooks/utils/useHtmlMeta';
import { useAuthentication } from '@/hooks/auth/useAuthentication';
import { useVersionCheck } from '@/hooks/utils/useVersionCheck';
import { useSignOut } from '@/hooks/auth/useSignOut';
import { useSnackbarMessage } from '@/models/global/snackbarMessage';
import { request } from '@/utils/api_client/sreshine';
import { useSessionCheck } from '@/hooks/auth/useSessionCheck';

const { isLoadingAuthState } = useAuthentication();
const { logoutHandler, visibilityChangeHandler } = useSessionCheck();
useVersionCheck();

request.inject();
// routerの切り替えでhtmlのheadを更新する処理を登録
useHtmlMeta();

const router = useRouter();
const { signOut } = useSignOut();
const { setSnackbarMessage } = useSnackbarMessage();

const forbiddenHandler = () => {
  router.push('/403');
};

const userInactiveHandler = async () => {
  try {
    await signOut();
  } catch {
    // サインアウトに失敗しても処理を継続する
  }
  setSnackbarMessage({
    message: 'アカウントが無効化されています',
    type: 'error',
  });
  try {
    await router.push('/auth/sign_in');
  } catch {
    // ルーティングエラーも握りつぶして未処理の Promise rejection を防ぐ
  }
};

// useAuthentication の onBeforeMount 内リクエストで dispatch されるイベントを
// 確実に捕捉するため、onMounted ではなく setup スコープで同期的に登録する
window.addEventListener('user-inactive', userInactiveHandler);

onMounted(() => {
  window.addEventListener('forbidden', forbiddenHandler);
  window.addEventListener('storage', logoutHandler);
  document.addEventListener('visibilitychange', visibilityChangeHandler);
});

onUnmounted(() => {
  window.removeEventListener('forbidden', forbiddenHandler);
  window.removeEventListener('user-inactive', userInactiveHandler);
  window.removeEventListener('storage', logoutHandler);
  document.removeEventListener('visibilitychange', visibilityChangeHandler);
});
</script>
<template>
  <v-app>
    <template v-if="!isLoadingAuthState">
      <router-view />
    </template>
    <BaseSnackbar />
  </v-app>
</template>
